import { ObjectClickHandlerAction } from "../../../utils/object-click-handler.js";
import { Oeuvre } from "../../classes/oeuvre.js";

export class ContextModalBodyObjectClickHandlerObjectSettingsComponentController {


    $scope;
    $rootScope;
    player;
    spherical360SetupService;
    oeuvresHandlerService;
    gettextCatalog;
    $sce;

    html_cache = {};
    
    static $inject = [ "$scope", "$rootScope", "$playerHandler", "spherical360SetupService", "$oeuvresHandler", "gettextCatalog", "$sce" ];

    constructor( $scope, $rootScope, playerHandlerService, spherical360SetupService, oeuvresHandlerService, gettextCatalog, $sce ) {
        this.$scope                   = $scope;
        this.$rootScope               = $rootScope;
        this.player                   = playerHandlerService.player;
        this.spherical360SetupService = spherical360SetupService;
        this.oeuvresHandlerService    = oeuvresHandlerService;
        this.gettextCatalog           = gettextCatalog;
        this.$sce                     = $sce;

        $scope.nact = null;
    }

    $onInit() {
        let { $scope, $rootScope } = this;

        $scope.extend = this.extend;
        $scope.data   = this.data;
        
        $scope.arrangement = $rootScope.arrangement
    }

    genNewEmptyAct( handler ) {

        var act = { conditions: [ '' ], fn: '', arguments: [] };

        if (handler.object instanceof Oeuvre) {
            act.fn = "openOeuvreInfoModal";
            this.onActFnChange( act.fn, act, handler );
        }

        return act;
    }

    addAct( act, handler ) {
        handler.pushAct( act );
    }

    onActFnChange( fn, act, handler ) {
        act.arguments = [];

        try {
            switch (fn) {
                case "setPlayerPositionRotation":
                    act.arguments = ObjectClickHandlerAction.buildDefaultArguments( "setPlayerPositionRotation", act, { player }); 
                    //act.arguments = [ this.player.pos.toArray(), this.player.av, this.player.ah ];
                    break;
                    
                case "openOeuvreInfoModal":
                    act.arguments = ObjectClickHandlerAction.buildDefaultArguments( "openOeuvreInfoModal", act, { handler }); 
                    //act.arguments = [ handler.object.uid ];
                    break;

                case "showTextContextMenu":
                    act.arguments = ObjectClickHandlerAction.buildDefaultArguments( "showTextContextMenu", act, {}); 
                    //act.arguments = [ "", "", { size: "" }];
                    break;
            }
        } catch (error) {
            console.error( error );
        }
    }

    genActHtmlString( act ) {

        let { gettextCatalog, spherical360SetupService, $rootScope } = this;

        var cache_key = JSON.stringify( act ), now = Date.now();

        if (this.html_cache[cache_key] && this.html_cache[cache_key].expires < now) {
            delete this.html_cache[cache_key];
        }

        if (!this.html_cache[cache_key]) {
            var str = "";
            
            var str_function = "", str_arguments = "", arr_arguments = [];
        
            if (act.conditions && Object.keys( act.conditions ).length > 0) {
                var parts = [];
                str = "Jos";

                for (var cond in act.conditions) {
                    var value = act.conditions[ cond ];

                    switch (cond) {
                        default:
                            var i18n_key = "label:object_click_condition-" + cond;
                            if (gettextCatalog.getStringIfExists( i18n_key )) {
                                parts.push( gettextCatalog.getString( i18n_key, { value: value }))
                            } else {
                                parts.push( cond );
                            }
                    }
                }

                for (var i = 0; i < parts.length; i++) {
                    str += "<code>"+parts[i]+"</code>";
                    if (i < parts.length - 2) {
                        str += ",";
                    } else if (i < parts.length - 1) {
                        str += " ja";
                    }
                    str += " ";
                }

                str += "niin ";
            }

            /*******/

            try {
                str_function = gettextCatalog.getStringIfExists( "label:object_click_fn-" + act.fn );
            } catch (error) {
                console.error( error );
            }

            try {
                switch (act.fn) {
                    case "attachPlayerToSpherical360Setup":

                        var setup = act.arguments[0] && spherical360SetupService.setups[ act.arguments[0] ];
                        if (setup) {
                            arr_arguments = [ setup.name || setup.uuid ];
                        }
                        break;
                    case "openOeuvreInfoModal":
                        var oeuvre = act.arguments[0] && $rootScope.oeuvres[ act.arguments[0] ];
                        if (oeuvre) {
                            arr_arguments = [ oeuvre.title || oeuvre.uid ];
                        }
                        break;
                }
            } catch (error) {
                console.error( error );
            }

            /**
             * Fallbackit
             */
        
            if (!str_function) {
                str_function = act.fn;
            }

            if (act.arguments[0] && arr_arguments.length != act.arguments.length) {
                arr_arguments = act.arguments;
            }
        
            /**
             * Viimeistely
             */
                
            str_function = "<code>" + str_function + "</code>";

            str_arguments = arr_arguments.map(function(argv) {
                return "<code>'"+argv+"'</code>";
            }).join( ", " );

            if (str_arguments) {
                str_arguments = " " + str_arguments + " ";
            }

            /************/

            str = str + str_function + "(" + str_arguments + ")";

            this.html_cache[cache_key] = {
                html: this.htmlStringToTrustedHtmlString( str ),
                expires: now + 10000
            };
        }

        return this.html_cache[cache_key].html;
    }

    htmlStringToTrustedHtmlString( html ) {
        return this.$sce.trustAsHtml( html );
    }
}

export const ContextModalBodyObjectClickHandlerObjectSettingsComponent = {

    selector: "context-modal-body-object-click-handler-object-settings",
    name: "contextModalBodyObjectClickHandlerObjectSettings",

    bindings: {
        extend: "=",
        data:   "=",
    },

    templateUrl: "templates/context-modals/objectClickHandler-inner.object-settings.html",
    controller: ContextModalBodyObjectClickHandlerObjectSettingsComponentController
};